import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import or from 'occamsrazor';
export var getJobStatus = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(apiUrl, jobId, setState) {
    var url, response, jsonResponse, saved;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = "".concat(apiUrl, "/").concat(jobId, "?_=").concat(Date.now());
            _context.prev = 1;
            _context.next = 4;
            return fetch(url, {
              method: 'GET'
            });

          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();

          case 7:
            jsonResponse = _context.sent;
            saved = jsonResponse.status === 200;
            setState(saved);
            _context.next = 16;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            setState(false);
            console.log('Error checking saved job status'); // eslint-disable-line no-console

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function getJobStatus(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var events = function () {
  if (typeof window !== 'undefined' && window.TES && window.TES.events) {
    return window.TES.events;
  }

  return or.registry('tes')('events');
}();

export var track = function track(eventTitle, id, name) {
  if (window._mz && window._mze) {
    global._mz.emit(global._mze.CLICK, {
      eventTitle: eventTitle,
      id: id,
      module: {
        type: 'save-job-button',
        name: name
      }
    });
  }
};
export var actions = {
  add: function add(type, action) {
    return events.add("tes:events:jobs:".concat(type), action);
  },
  trigger: function trigger(type, state, jobId) {
    return events.trigger("tes:events:jobs:".concat(type), jobId, state);
  },
  remove: function remove(type, action) {
    return events.remove("tes:events:jobs:".concat(type), action);
  }
};
export var isUserLoggedIn = function isUserLoggedIn() {
  return typeof window !== 'undefined' && document.cookie.indexOf('TESCookieUser=') !== -1;
};

var AuthHelper = /*#__PURE__*/function () {
  function AuthHelper(trackTask, task) {
    var updateUITask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
      return true;
    };
    var dismissTask = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
      return true;
    };

    _classCallCheck(this, AuthHelper);

    this.trackTask = trackTask;
    this.task = task;
    this.updateUITask = updateUITask;
    this.dismissTask = dismissTask;
  }

  _createClass(AuthHelper, [{
    key: "listenForLogin",
    value: function listenForLogin() {
      var _this = this;

      events.on('logged-in', function () {
        if (_this.pendingTask) {
          _this.pendingTask = false;

          _this.task();
        } else {
          /* the login modal had been opened by some other means eg. link in header. So just update */
          _this.updateUITask();
        }
      });
      return events.on('modal-close', 'authapp', function () {
        return true;
      });
    }
  }, {
    key: "actionIfLoggedIn",
    value: function actionIfLoggedIn() {
      try {
        this.trackTask();

        if (isUserLoggedIn()) {
          this.task();
        } else {
          // this will be always be triggered and forget
          var reloadPageOnSuccess = false;
          events.one('modal-ready', events.trigger('auth-open', 'sign-in', reloadPageOnSuccess));
        }
      } finally {
        this.pendingTask = true;
      }
    }
  }]);

  return AuthHelper;
}();

export { AuthHelper as default };